import { SoapUtils } from '../../../../utils/SoapUtils';
import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface Document {
    id?:             string;
    acl?:            string;
    parent?:         string;
    name?:           string;
    description?:    string;
    type?:           string;
    location?:       string;
    category?:       string;
    validByDate?:    string;
    createdBy?:      string;
    fileHandle?:     string;
    treeHandle?:     string;
    fileSize?:       string;
    internalNumber?: string;
    fileName?:       string;
    deleted?:        string;
    creationDate?:   Date;
    lastChangeDate?: Date;
    validFrom?:      Date;
    validTo?:        Date;
    deleteDate?:     Date;
    storageId?:      string;
    isInStorage?:    string;
    contextId?:      string;
}

function toDocumentXml(document: Document):string{
    var xml = '<DOCUMENT>';
    xml += SoapUtils.makeNode(document.id, 'id');
    xml += SoapUtils.makeNode(document.acl, 'acl');
    xml += SoapUtils.makeNode(document.parent, 'parent');
    xml += SoapUtils.makeNode(document.name, 'name');
    xml += SoapUtils.makeNode(document.description, 'description');
    xml += SoapUtils.makeNode(document.type, 'type');
    xml += SoapUtils.makeNode(document.location, 'location');
    xml += SoapUtils.makeNode(document.category, 'category');
    xml += SoapUtils.makeNode(document.validByDate, 'validByDate');
    xml += SoapUtils.makeNode(document.createdBy, 'createdBy');
    xml += SoapUtils.makeNode(document.fileHandle, 'fileHandle');
    xml += SoapUtils.makeNode(document.treeHandle, 'treeHandle');
    xml += SoapUtils.makeNode(document.fileSize, 'fileSize');
    xml += SoapUtils.makeNode(document.internalNumber, 'internalNumber');
    xml += SoapUtils.makeNode(document.fileName, 'fileName');
    xml += SoapUtils.makeNode(document.deleted, 'deleted');
    xml += SoapUtils.makeNode(SoapUtils.toDateForXml(document.creationDate), 'creationDate');
    xml += SoapUtils.makeNode(SoapUtils.toDateForXml(document.lastChangeDate), 'lastChangeDate');
    xml += SoapUtils.makeNode(SoapUtils.toDateForXml(document.validFrom), 'validFrom');
    xml += SoapUtils.makeNode(SoapUtils.toDateForXml(document.validTo), 'validTo');
    xml += SoapUtils.makeNode(SoapUtils.toDateForXml(document.deleteDate), 'deleteDate');
    xml += SoapUtils.makeNode(document.storageId, 'storageId');
    xml += SoapUtils.makeNode(document.isInStorage, 'isInStorage');
    xml += SoapUtils.makeNode(document.contextId, 'contextId');
    xml += '</DOCUMENT>';
    return xml;
}
export interface ICreateDocumentInStorageRequest extends IBaseRequest {
    DOCUMENT:      Document;
    data:          string;
}

export class CreateDocumentInStorageRequest extends BaseRequest implements ICreateDocumentInStorageRequest {
    public DOCUMENT: Document;
    public data:     string;
    constructor(server: string, session: string, document: Document, data: string) {
        super(server, session);
        this.DOCUMENT = document;
        this.data = data;
    }

    public toXml(): string {
        var parameters: string = super.toXml();
        parameters += toDocumentXml(this.DOCUMENT);
        parameters += this.makeNode(this.data, 'data');
        return super.wrapperXml('CreateDocumentInStorage', parameters);
    }
}
